/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PassengerSeat } from './PassengerSeat';
import {
    PassengerSeatFromJSON,
    PassengerSeatFromJSONTyped,
    PassengerSeatToJSON,
    PassengerSeatToJSONTyped,
} from './PassengerSeat';

/**
 * 
 * @export
 * @interface FlightSegment
 */
export interface FlightSegment {
    /**
     * 
     * @type {string}
     * @memberof FlightSegment
     */
    departureIata?: string;
    /**
     * Airport-local departure date and time without a timezone or UTC offset.
     * @type {string}
     * @memberof FlightSegment
     */
    departureDatetime?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightSegment
     */
    arrivalIata?: string;
    /**
     * Airport-local arrival date and time without a timezone or UTC offset.
     * @type {string}
     * @memberof FlightSegment
     */
    arrivalDatetime?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightSegment
     */
    flightNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightSegment
     */
    flightOperatingCarrier?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightSegment
     */
    marketingOperatingCarrier?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightSegment
     */
    ticketClass?: string;
    /**
     * 
     * @type {number}
     * @memberof FlightSegment
     */
    departureAirportLatitude?: number;
    /**
     * 
     * @type {number}
     * @memberof FlightSegment
     */
    departureAirportLongitude?: number;
    /**
     * 
     * @type {number}
     * @memberof FlightSegment
     */
    arrivalAirportLatitude?: number;
    /**
     * 
     * @type {number}
     * @memberof FlightSegment
     */
    arrivalAirportLongitude?: number;
    /**
     * 
     * @type {Array<PassengerSeat>}
     * @memberof FlightSegment
     */
    passengerSeats?: Array<PassengerSeat>;
    /**
     * True if this is a one way trip or the outbound leg of a round trip.
     * @type {boolean}
     * @memberof FlightSegment
     */
    outboundLeg?: boolean;
}

/**
 * Check if a given object implements the FlightSegment interface.
 */
export function instanceOfFlightSegment(value: object): value is FlightSegment {
    return true;
}

export function FlightSegmentFromJSON(json: any): FlightSegment {
    return FlightSegmentFromJSONTyped(json, false);
}

export function FlightSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSegment {
    if (json == null) {
        return json;
    }
    return {
        
        'departureIata': json['departure_iata'] == null ? undefined : json['departure_iata'],
        'departureDatetime': json['departure_datetime'] == null ? undefined : json['departure_datetime'],
        'arrivalIata': json['arrival_iata'] == null ? undefined : json['arrival_iata'],
        'arrivalDatetime': json['arrival_datetime'] == null ? undefined : json['arrival_datetime'],
        'flightNumber': json['flight_number'] == null ? undefined : json['flight_number'],
        'flightOperatingCarrier': json['flight_operating_carrier'] == null ? undefined : json['flight_operating_carrier'],
        'marketingOperatingCarrier': json['marketing_operating_carrier'] == null ? undefined : json['marketing_operating_carrier'],
        'ticketClass': json['ticket_class'] == null ? undefined : json['ticket_class'],
        'departureAirportLatitude': json['departure_airport_latitude'] == null ? undefined : json['departure_airport_latitude'],
        'departureAirportLongitude': json['departure_airport_longitude'] == null ? undefined : json['departure_airport_longitude'],
        'arrivalAirportLatitude': json['arrival_airport_latitude'] == null ? undefined : json['arrival_airport_latitude'],
        'arrivalAirportLongitude': json['arrival_airport_longitude'] == null ? undefined : json['arrival_airport_longitude'],
        'passengerSeats': json['passenger_seats'] == null ? undefined : ((json['passenger_seats'] as Array<any>).map(PassengerSeatFromJSON)),
        'outboundLeg': json['outbound_leg'] == null ? undefined : json['outbound_leg'],
    };
}

export function FlightSegmentToJSON(json: any): FlightSegment {
    return FlightSegmentToJSONTyped(json, false);
}

export function FlightSegmentToJSONTyped(value?: FlightSegment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'departure_iata': value['departureIata'],
        'departure_datetime': value['departureDatetime'],
        'arrival_iata': value['arrivalIata'],
        'arrival_datetime': value['arrivalDatetime'],
        'flight_number': value['flightNumber'],
        'flight_operating_carrier': value['flightOperatingCarrier'],
        'marketing_operating_carrier': value['marketingOperatingCarrier'],
        'ticket_class': value['ticketClass'],
        'departure_airport_latitude': value['departureAirportLatitude'],
        'departure_airport_longitude': value['departureAirportLongitude'],
        'arrival_airport_latitude': value['arrivalAirportLatitude'],
        'arrival_airport_longitude': value['arrivalAirportLongitude'],
        'passenger_seats': value['passengerSeats'] == null ? undefined : ((value['passengerSeats'] as Array<any>).map(PassengerSeatToJSON)),
        'outbound_leg': value['outboundLeg'],
    };
}

